<template>
	<div class="basis-page-cls breath-report-form">
		<table-search-index @filterSelectRemote="filterSelectRemote" :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" @resetBasicFilter="resetBasicFilter">
			<div class="table-search-box__items-dynamic" v-for="(item,index) in dynamicHeader" :key="index">
				<label>{{item.label}}{{index+1}}：</label>
				 <el-select size="small" clearable v-model="item.model" :disabled="!listQuery.subjectId" placeholder="请选择" style="width: 180px;" filterable @focus="onDynamicEvent">
				    <el-option
				      v-for="(item,index) in dynamicOptions"
				      :key="index"
				      :label="item.originalColumnName"
				      :value="item.originalColumnCode">
				    </el-option>
				  </el-select>
				<el-select clearable v-model="item.selectVal" :disabled="!listQuery.subjectId"  placeholder="请选择" style="width: 140px;margin: 0 10px;" size="small">
					<el-option label="大于" value="gtq"></el-option>
					<el-option label="不等于" value="neq"></el-option>
					<el-option label="小于" value="ltq"></el-option>
					<el-option label="等于" value="eq"></el-option>
				</el-select>
				<el-input size="small" clearable :disabled="!listQuery.subjectId" placeholder="请输入内容" v-model="item.inputVal" style="width: 150px;"></el-input>
				<i class="el-icon-circle-plus-outline" style="margin: 0 5px;" @click="addDynamic"></i>
				<i class="el-icon-delete-solid" @click="removeDynamic(index)" v-show="index != 0"></i>
			</div>
		</table-search-index>
		<section class="basis-cls_table">
		    <div class="header">
		        <span class="title el-icon-document"> 数据列表</span>
		        <div class="btns">
					<el-button :loading="loading" type="primary" size="small" class="right" @click.stop="onExport" icon="el-icon-download">导出</el-button>
		        </div>
		    </div>
		    <div class="table">
				<table-pagination
					v-loading="page_loading"
					ref="taskTable"
		            pagination
		            :data="list"
		            :column="column"
		            :total="total"
		            :page.sync="listQuery.pageNumber"
		            :limit.sync="listQuery.pageSize"
		            @pagination="getList"></table-pagination>
		    </div>
		</section>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import {formatDate } from 'utils/index';
    import { filterHeaderSearch } from '@/utils/mixins';
	
	export default {
		mixins:[filterHeaderSearch],
		computed: {
		    ...mapGetters([
				'userInfo',  
				'subBrandList'
			])
		},
		data() {
			return {
				loading:false,
				page_loading:false,
				filterHeader: [
					{label: '子品牌', model: 'childBrandIdentify', type: 'select', default: '', list: []},
					{label: '执行坐席', model: 'userId', type: 'select',  default: '', list: [], loading:false,isRemote:true,labelName:'account',valueName:'userId',childLabelName:'nickname'},
					{label: '外呼主题', model: 'subjectId', type: 'select', default: '', list: [], loading:false,isRemote:true, labelName:'subjectName',valueName:'subjectId',child_model:'originalBatchNum'},
					{label: '数据文件', model: 'originalBatchNum', type: 'select', default: '',list: [], loading:false,isRemote:true,p_model:'subjectId'},
					{label: '外呼分类', model: 'campaignId', type: 'select', default: '',list: [], loading:false,isRemote:true,labelName:'campaignName',valueName:'campaignId'},
					{label: '任务状态', model: 'taskStatus', type: 'select', default: '',list: [], loading:false,isRemote:true,labelName:'statusName',valueName:'statusCode',multiple:true},
					{label: '外呼电话', model: 'phoneNumber', type: 'input', default: '', placeholder: '请输入外呼电话'},
					{label: '是否完成', model: 'isFinish', type: 'select', default: '', list: [{name:'是',id:'1'},{name:'否',id:'0'}]},
					{label: '外呼问卷', model: 'paperId', type: 'select', default: '',list: [], loading:false,isRemote:true,labelName:'paperName',valueName:'paperId'},
					{label: '外呼时间', model: 'date1', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '预约时间', model: 'date2', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '拨打时间', model: 'date3', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '任务创建时间', model: 'date4', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '自定义', model: 'customQueryParams', type: 'dynamic', default: ''},
				],
				dynamicHeader:[
					{label:'条件',inputVal:"",selectVal:'eq',model:''}
				],
				dynamicOptions:[],
				listQuery:{
					pageNumber:1,
					pageSize:10,
					brandIdentify:'',
					childBrandIdentify:'',
					subjectId:'',
					campaignId:'',
					taskStatus:'',
					phoneNumber:'',
					isFinish:'',
					batchNum:'',
					originalBatchNum:'',
					paperId:'',
					date1:'',
					date2:'',
					date3:'',
					date4:'',
					customQueryParams:'',
					startObTime:'',
					endObTime:'',
					userId:''
				},
				column:[
					// {
					//     label: '序号',
					//     width: 80,
					//     render: (h, scope) => {
					//         return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}</span>
					//     }
					// },
					// { label: '任务编号', prop: 'task_id' },
					// { label: '外呼活动', prop: 'campaign_name' },
					// { label: '外呼主题', prop: 'subject_name' },
					// { label: '外呼问卷', prop: 'paper_name' },
					// { label: '子品牌', prop: 'child_brand_identify' },
					// { label: '最后外呼时间', prop: 'create_time' },
					// { label: '是否完成', prop: 'is_finish_name' },
					// { label: '任务状态', prop: 'task_status_name' },
					// { label: '执行坐席', prop: 'taskId' },
					
				],
				list:[],
				total:0,
			}
		},
		methods: {
			onExport() {
				// if(!this.listQuery.originalBatchNum || !this.listQuery.subjectId){
				// 	this.$message.error("请先选择主题名称/数据文件");
				// 	return;
				// }
				if(!this.listQuery.date1 && !this.listQuery.date2 && !this.listQuery.date3 && !this.listQuery.date4) {
					this.$message.error("请选择时间范围一个月内的时间段导出");
					return;
				}
				if(this.listQuery.date1) {
					let start1 = new Date(this.listQuery.date1[0]).getTime();
					let end1 = new Date(this.listQuery.date1[1]).getTime();
					if(Math.floor((end1 - start1) / (24*3600*1000)) > 31){
						this.$message.error("请选择时间范围一个月内的时间段导出");
						return;
					}
				}
				if(this.listQuery.date2) {
					let start1 = new Date(this.listQuery.date2[0]).getTime();
					let end1 = new Date(this.listQuery.date2[1]).getTime();
					if(Math.floor((end1 - start1) / (24*3600*1000)) > 31){
						this.$message.error("请选择时间范围一个月内的时间段导出");
						return;
					}
				}
				if(this.listQuery.date3) {
					let start1 = new Date(this.listQuery.date3[0]).getTime();
					let end1 = new Date(this.listQuery.date3[1]).getTime();
					if(Math.floor((end1 - start1) / (24*3600*1000)) > 31){
						this.$message.error("请选择时间范围一个月内的时间段导出");
						return;
					}
				}
				if(this.listQuery.date4) {
					let start1 = new Date(this.listQuery.date4[0]).getTime();
					let end1 = new Date(this.listQuery.date4[1]).getTime();
					if(Math.floor((end1 - start1) / (24*3600*1000)) > 31){
						this.$message.error("请选择时间范围一个月内的时间段导出");
						return;
					}
				}
				this.loading = true;
				this.$api.exportBreathreportFormList(this.listQuery).then(res => {
					if(res.errcode != 0) {
						this.loading = false;
						return;
					};
					// this.$api.downloadBreathreportFormByName(res.data.fileName).then(res => {
					// 	if(res.errcode != 0) {
					// 		this.loading = false;
					// 		return;
					// 	};
						// let blob = new Blob([res], {type: "application/vnd.ms-excel"})
						// var timestamp = (new Date()).valueOf();
						// const fileName = timestamp+'.xls'
						// if ('download' in document.createElement('a')) { // 非IE下载
						//  const elink = document.createElement('a')
						//  elink.download = fileName
						//  elink.style.display = 'none'
						//  elink.href = window.URL.createObjectURL(blob)
						//  document.body.appendChild(elink)
						//  elink.click()
						//  window.URL.revokeObjectURL(elink.href) // 释放URL 对象
						//  document.body.removeChild(elink)
						// } else { // IE10+下载
						//  navigator.msSaveBlob(blob, fileName)
						// }
						this.$message.success('已创建任务，请在通知栏查看');
						this.loading = false;
					}).catch(() => {
						this.loading = false;
					})
				// })
			},
			getList(){
				if(!this.listQuery.originalBatchNum || !this.listQuery.subjectId){
					this.$message.error("请先选择主题名称/数据文件");
					this.page_loading = false;
					return;
				}
				this.listQuery.customQueryParams = this.getDynamicHeader();
				this.listQuery.batchNum = this.listQuery.originalBatchNum;

				this.$api.getBreathreportFormList(this.listQuery).then(res => {
					this.page_loading = false;
					if(res.errcode != 0) return;
					this.list = res.data;
					this.total = Number(res.total);
				}).catch((err) => {
					this.page_loading = false;
				})
			},
			getColumn(){
				this.$api.getBreathdataBaseColumnList({
					batchNum:this.listQuery.originalBatchNum,
					brandIdentify:this.listQuery.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					let results = [];
					for(let item of res.data){
						if(item.originalColumnCode == 'task_created'){
							results.push({
								label:item.originalColumnName,
								prop:item.originalColumnCode,
								render: (h, scope) => {
								    return <span>{scope.row[item.originalColumnCode] == '1' ?'是' : '否'}</span>
								}
							})
						}else {
							results.push({
								label:item.originalColumnName,
								prop:item.originalColumnCode,
							})
						}
						
					}
					this.column = results;
				})
			},
			filterSearch(){
				this.page_loading = true;
				this.getColumn();
				this.listQuery.pageNum = 1;
				this.getList()
			},
			resetBasicFilter(){
				this.dynamicHeader = [{label:'条件',inputVal:"",selectVal:'eq',model:''}]
			},
			addDynamic(){
				this.dynamicHeader.push({label:'条件',inputVal:"",selectVal:'eq',model:''});
			},
			removeDynamic(index){
				 this.dynamicHeader.splice(index, 1)
			},
			onDynamicEvent(){
				if(!this.listQuery.originalBatchNum){
					this.$message.error("请先选择数据文件");
					return;
				}
				this.$api.getBreathdataBaseColumnList({
					batchNum: this.listQuery.originalBatchNum,
					brandIdentify: this.listQuery.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					this.dynamicOptions = res.data;
				})
			},
			getDynamicHeader(){
				let results =[];
				this.dynamicHeader.map(item => {
					if(item.model && item.inputVal){
						results.push(`${item.model}::${item.selectVal}::${item.inputVal}`)
					}
				})
				results = results.length > 0 ? results.join('#') : '';
				return results
			},
		},
		async created(){
			this.filterHeader[0]['list'] = this.subBrandList;
			this.listQuery.brandIdentify = this.userInfo.brandIdentify;
			this.listQuery.childBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
			const end = new Date();
			const start = new Date();
			start.setMonth(start.getMonth() - 1);
		}
	}
</script>

<style lang="scss" scoped>
	.breath-report-form {
		
	}
</style>
